import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { consoleLog } from 'utils/simpleLogger'

import Redirect from 'pages/RegA/Redirect'
import Reinvest from 'pages/Reinvest'
import Registration from './pages/RegA'

function App() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    consoleLog('App location', location)
    if (location.pathname === '/') {
      if (location.pathname.length === 1) {
        navigate('/registration?regulation=reg-a&step=email')
      }
    } else if (location.pathname === '/registration' && location.search === '') {
      navigate('/registration?regulation=reg-a&step=email')
    }
  }, [location.pathname]) // eslint-disable-line

  return (
    <div>
      <Routes>
        <Route path="/registration" element={<Registration />} />
        <Route path="/reinvest" element={<Reinvest />} />

        <Route path="*" element={<Redirect />} />
      </Routes>
    </div>
  )
}

export default App
